// extracted by mini-css-extract-plugin
module.exports = {"logoutButton":"LoginSignupButton_logoutButton__2LNU8"};